import { FIELD_TYPES } from "constants/template-field-type";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ParagraphConfig from "segments/desktop/core-components/paragraph/fields-config";

const { titleColor, ...restOfTitleConfig } = TitleConfig;
const { bodyColor, ...restOfParagraphConfig } = ParagraphConfig;

export default {
  tabsTitle: {
    type: FIELD_TYPES.NESTED,
    label: "Title",
    fields: TitleConfig
  },
  tabs: {
    type: FIELD_TYPES.MULTIPLE_NESTED,
    label: "Tabs",
    nestedConfig: {
      type: FIELD_TYPES.NESTED,
      fields: {
        productType: { type: FIELD_TYPES.PRODUCTS, label: "Product type" },
        title: {
          type: FIELD_TYPES.NESTED,
          label: "Tab title",
          fields: {
            productImage: { type: FIELD_TYPES.GALLERY, label: "Product logo image" },
            ...restOfTitleConfig,
            ...restOfParagraphConfig,
            useCases: {
              type: FIELD_TYPES.MULTIPLE_NESTED,
              label: "Use cases",
              nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: {
                  useCase: { type: FIELD_TYPES.TEXT, label: "Use cases" }
                }
              }
            }
          }
        },
        content: {
          type: FIELD_TYPES.NESTED,
          label: "Product content",
          fields: {
            features: {
              type: FIELD_TYPES.MULTIPLE_NESTED,
              label: "Features",
              nestedConfig: {
                type: FIELD_TYPES.NESTED,
                fields: {
                  feature: { type: FIELD_TYPES.TEXT, label: "Feature" }
                }
              }
            },
            ctaText: { type: FIELD_TYPES.TEXT, label: "CTA text" }
          }
        }
      }
    }
  },
  tabTitleConfig: {
    type: FIELD_TYPES.NESTED,
    label: "Tabs titles",
    fields: {
      textWidth: { type: FIELD_TYPES.TEXT, label: "Text max width" },
      titleWidth: { type: FIELD_TYPES.TEXT, label: "Title max width" },
      spaceFromParagraph: { type: FIELD_TYPES.TEXT, label: "Margin between title and text" }
    }
  }
};
